import React from 'react';
import ListView from '../Common/Views/ListView';

import { itemTypeToLabel } from './itemUtils';

const ItemCategoriesList = ({
    type = null, // 'PRODUCT' or 'SERVICE' - determines which categories to show
    addButton = true,
    onSelect = null, // a function to override the table row click action
    columns = null, // array if specific columns from the columnsConfig to show in the list view. If null, all columns will be shown.
    filters = {}, // additional filters to apply to the API call
}) => {

    // Merge type into filters
    const mergedFilters = { ...filters };
    if (type) {
        mergedFilters.type = type;
    }

    // Determine URL prefix based on type
    const typePathSegment = type === 'SERVICE' ? 'services' : 'products';

    // Columns configuration for rendering item categories list
    const columnsConfig = {
        name: {
            key: 'name',
            label: 'Name',
            render: row => row.name
        },
        type: {
            key: 'type',
            label: 'Type',
            render: row => itemTypeToLabel(row.type)
        },
        description: {
            key: 'description',
            label: 'Description',
            render: row => row.description
        },
        status: {
            key: 'status',
            label: 'Status',
            render: row => (row.isActive ? 'Active' : 'Inactive')
        },
    };

    return <ListView
        title={type ? `${itemTypeToLabel(type)} Categories` : 'Item Categories'}
        apiPath={"/tenants/items/categories"}
        filters={mergedFilters}
        addPath={`/items/categories/${typePathSegment}/add`}
        addButton={addButton}
        addButtonLabel={`Add new ${type ? itemTypeToLabel(type).toLowerCase() : 'item'} category`}
        rowClickPath={(item) => `/items/categories/${typePathSegment}/${item.id}`}
        onSelect={onSelect} // just a null function so on select doesn't do anything by default
        columnsConfig={columnsConfig}
        columns={columns}
        searchBox={true}
        searchAttributes={[
            { name: "name", label: "Name", type: "text" },
        ]}
        noResultsMessage="No item categories found"
    />
};

export default ItemCategoriesList;